'use client'

import { useEffect } from 'react'
import { tracking } from '@/tracking'

export function BlogPostViewTracker({
  title,
  url,
}: {
  title: string
  url: string
}) {
  useEffect(() => {
    tracking.track('Viewed blog post', {
      'Blog post title': title,
      'Blog post URL': url,
    })
  }, [title, url])

  return null
}
